import { type FC, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import { useCurrentMapContext } from 'src/lib/customHooks/useCurrentMapContext';
import { EventEditor } from '../../components/EventEditor/EventEditor';
import { useStore } from '../../store/reducers';

export const EventEditorView: FC = () => {
  const { eventId } = useParams<{ eventId: string }>();
  const currentEvent = useStore((s) => s.events.getter.currentEvent());
  const { loadCurrentEvent, clearCurrentEvent } = useStore((s) => s.events.actions);
  const mapContexts = useStore((s) => s.maps.ctxs);
  const currentMapContext = useCurrentMapContext();
  const { createMapContext, setCurrentMapId } = useStore((s) => s.maps.actions);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    (async () => {
      if (eventId != null && (currentEvent == null || currentEvent.id !== eventId)) {
        await loadCurrentEvent(eventId);
      }
    })();

    return function cleanup() {
      clearCurrentEvent();
      setCurrentMapId(null);
    };
  }, [eventId]);

  useEffect(() => {
    if (currentMapContext == null && currentEvent != null) {
      const mapId = `map-editor-${currentEvent.id}`;
      if (!mapContexts.has(mapId)) {
        createMapContext(mapId, currentEvent, {
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
      setCurrentMapId(mapId);
    }
  }, [currentMapContext, currentEvent]);

  useEffect(() => {
    if (location.pathname.match(/\/admin\/events\/[a-f0-9]+\/?$/)) {
      if (location.pathname.endsWith('/')) {
        navigate(`${location.pathname}basic`, { replace: true });
      } else {
        navigate(`${location.pathname}/basic`, { replace: true });
      }
    }
  }, [location]);

  if (eventId == null || currentEvent == null) return <></>;

  return <EventEditor />;
};
